import React from 'react';
import { Switch, Route, MemoryRouter, Redirect } from 'react-router-dom';

import Navigation from '../components/Navigation';
import Sheet from '../pages/Sheet';

import InformedHeader from '../components/InformedHeader';

type RoutesProps = {
  sheetId: string;
};

const Routes: React.FC<RoutesProps> = ({ sheetId }: RoutesProps) => {
  return (
    <MemoryRouter>
      {/* <NavBar /> */}
      <InformedHeader />
      <Navigation />
      <Switch>
        <Redirect exact from="/" to={sheetId} />
        {/* <Route path="/:sheetId" component={withTracker(Sheet)} /> */}
        <Route path="/:sheetId" component={Sheet} />
      </Switch>
    </MemoryRouter>
  );
};
export default Routes;
